import React from 'react';
import Icon from './Icon';

const ExportIcon = (props) => (
    <Icon {...props}>
        <path
            d="M4 14V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V14M12 3V14M12 14L7.5 9.5M12 14L16.5 9.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ExportIcon;
